module.exports = __webpack_public_path__ + "img/25.a18bf48c.gif";